// extracted by mini-css-extract-plugin
module.exports = {"table":"table--7+q7N"};